module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"nl-NL":{"yes":"Ja","no":"Nee"},"nl-BE":{"yes":"Ja","no":"Nee"},"es-ES":{"yes":"Si","no":"No"},"de-DE":{"yes":"Ja","no":"Nein"},"fr-BE":{"yes":"Oui","no":"Non"},"fr-FR":{"yes":"Oui","no":"Non"}}')
  delete Component.options._Ctor
}
